import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { RetentionsModel } from 'src/app/models/invoicing/retentionsModel';
import { PreinvoicingPrintModel } from 'src/app/models/print/invoicing/preinvoicing-print.model';
import { environment } from 'src/environments/environment';
import { MovementModel } from './../../models/invoicing/movement.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';

@Injectable({
  providedIn: 'root'
})
export class MovementService {

  private readonly _httpClient = inject(HttpClient);

  exportPreinvoices(filters: ColumnResponseModel[], invoicingCutoffId: number): Observable<Blob> {
    const params = new HttpParams().set('invoicingCutoffId', invoicingCutoffId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.ExportPreinvoicesAsync}`,
      filters, { params, responseType: 'blob' }
    );
  }

  getAllMovementsByInvoicingCutoffId(invoicingCutoffId: number): Observable<Array<MovementModel>> {
    return this._httpClient.get<Array<MovementModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetAllMovementsByInvoicingCutoffId}/${invoicingCutoffId}`);
  }

  getBaseIvaByMovementAndConcept(movementId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetBaseIvaByMovementAndConcept}/${movementId}/${conceptInvoicingId}`);
  }

  getPrintPreinvoices(invoicingCutoffId: number, clientId: number | null, costCenterTypeId: number | null, costCenterId: number | null): Observable<Array<PreinvoicingPrintModel>> {
    let params = new HttpParams()
    params = params.set('invoicingCutoffId', invoicingCutoffId.toString());
    if (clientId !== null)
      params = params.set('clientId', clientId.toString());
    if (costCenterTypeId !== null)
      params = params.set('costCenterTypeId', costCenterTypeId.toString());
    if (costCenterId !== null)
      params = params.set('costCenterId', costCenterId.toString());
    return this._httpClient.get<Array<PreinvoicingPrintModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetPrintPreinvoices}`,
      { params: params }
    );
  }

  getReteFuenteByMovementAndConcept(movementId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetReteFuenteByMovementAndConcept}/${movementId}/${conceptInvoicingId}`);
  }

  getReteIcaByMovementAndConcept(movementId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetReteIcaByMovementAndConcept}/${movementId}/${conceptInvoicingId}`);
  }

  getRetentionsByMovement(movementId: number): Observable<Array<RetentionsModel>> {
    return this._httpClient.get<Array<RetentionsModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetRetentionsByMovement}/${movementId}`);
  }

  getRetentionsByMovements(movementIds: number[]): Observable<any> {
    return this._httpClient.post<any>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.movement.GetRetentionsByMovements}`,
      movementIds
    );
  }
}
